export function getPublicSupabaseEnv() {
  const url = process.env.NEXT_PUBLIC_SUPABASE_URL;
  const anonKey = process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY;

  if (!url || !anonKey) {
    throw new Error("Missing NEXT_PUBLIC_SUPABASE_URL or NEXT_PUBLIC_SUPABASE_ANON_KEY.");
  }

  return { url, anonKey };
}

export function hasPublicSupabaseEnv() {
  return Boolean(process.env.NEXT_PUBLIC_SUPABASE_URL && process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY);
}

export function getServiceRoleKey() {
  const key = process.env.SUPABASE_SERVICE_ROLE_KEY;
  if (!key) throw new Error("Missing SUPABASE_SERVICE_ROLE_KEY.");
  return key;
}

export function getAdminEmails() {
  return (process.env.ADMIN_EMAILS ?? "")
    .split(",")
    .map((email) => email.trim().toLowerCase())
    .filter(Boolean);
}

export function getCloudinaryCloudName() {
  const value = process.env.CLOUDINARY_CLOUD_NAME;
  if (!value) throw new Error("Missing CLOUDINARY_CLOUD_NAME.");
  return value;
}

export function getCloudinaryApiKey() {
  return process.env.CLOUDINARY_API_KEY ?? "";
}

export function getCloudinaryApiSecret() {
  return process.env.CLOUDINARY_API_SECRET ?? "";
}

export function getCloudinaryUploadPreset() {
  return process.env.CLOUDINARY_UPLOAD_PRESET ?? "";
}

export function getCloudinaryAdminFolder() {
  return process.env.CLOUDINARY_ADMIN_FOLDER ?? "neighbourhood-voice/admin";
}

export function getResendApiKey() {
  return process.env.RESEND_API_KEY ?? "";
}

export function getEmailFrom() {
  return process.env.EMAIL_FROM ?? "Neighbourhood Voice <hello@neighbourhoodvoice.com.au>";
}

export function getContactAdminEmail() {
  const [firstAdmin] = getAdminEmails();
  return process.env.CONTACT_ADMIN_EMAIL ?? firstAdmin ?? "hello@neighbourhoodvoice.com.au";
}
